<template>
    <div v-if="trainerPosition" class="twf-root" :style="bgStyle">
        <div class="twf-content">
            <div class="twf-top-row">
                <div class="twf-square-tile" :class="{'twf-square-tile--disabled': isLoading}" @click="!isLoading && travel()">
                    <div class="twf-back-badge-img" :style="wildImgStyle"/>
                    <div class="twf-square-label">{{ $t('common.backToWild') }}</div>
                </div>
                <!-- placeholder pro další čtvereček do budoucna - drží místo ve dvousloupcovém gridu -->
                <div class="twf-square-placeholder"/>
            </div>

            <div class="twf-congrats-card" :class="$vuetify.theme.dark ? 'transparent03--dark white--text' : 'transparent03 black--text'">
                <div class="twf-badge-block">
                    <div class="twf-congrats-title">{{ $t('common.congratulations') }}</div>
                    <div class="twf-congrats-subtitle">{{ $t('journey.trainerWildFightWin.congratsSubtitlePrefix') }}<strong>{{ trainerPosition.trainerFight.trainer.name }}</strong>{{ $t('journey.trainerWildFightWin.congratsSubtitleSuffix') }}</div>
                    <div class="twf-trainer-img-wrap">
                        <v-img
                            v-if="trainerPosition.trainerFight.trainer.img"
                            :src="require(`@/assets/pic/trainer/${trainerPosition.trainerFight.trainer.img}`)"
                            class="twf-trainer-img"
                            height="100%"
                            contain
                        />
                    </div>
                </div>
                <div class="twf-toplist-scroll">
                    <ToplistTable
                        :toplist="toplist"
                        :headers="[$t('journey.trainerWildFightWin.headerTrainer'), $t('journey.trainerWildFightWin.headerDay'), $t('journey.trainerWildFightWin.headerDate')]"
                        :keys="['trainer','days','created']"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // Win obrazovka po výhře nad divokým trenérem, stejný vizuální jazyk jako
    // TrainerFightWinNext.vue (stadion). Rozdíly oproti stadionu: žádná Knowegle
    // dlaždice/popup (diví trenéři nemají obstacle-hint), "back" čtvereček je
    // sám a vede zpět do WILD (ne do města - travel() bez cityId pokračuje na
    // WILD, jako starý "Continue" button); congrats karta místo odznaku ukazuje
    // poraženého trenéra (trainerFight.trainer.img je v serializační skupině
    // "position", žádný extra fetch navíc). Design viz claude/components/journey-dungeon.md.
    import {mapActions, mapGetters} from 'vuex';
    import * as journeyApi from '@/api/journeyApi';
    import ToplistTable from '@/components/journey/positions/pieces/ToplistTable';

    export default {
        name: 'TrainerWildFightWinNext',
        components: {ToplistTable},
        props: {
            trainerPosition: {type: Object, default: null},
        },
        data() {
            return {
                toplist: [],
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/item',
                isLoading: 'journey/isLoading',
            }),
            bgStyle() {
                return {backgroundImage: `url(${require('@/assets/pic/roads/' + this.trainerPosition.city.id + '.png')})`};
            },
            wildImgStyle() {
                // stejný obrázek jako dlaždice "Wild road" v CityNext.vue
                return {backgroundImage: `url(${require('@/assets/pic/web/forest.png')})`};
            },
        },
        watch: {
            trainerPosition() {
                this.getToplist();
            }
        },
        created() {
            this.trainerInfoMessages(this.user.id);
            this.getToplist();
        },
        methods: {
            ...mapActions({
                fetchData: 'journey/fetchObject',
                positionPost: 'journey/positionPost',
                trainerInfoMessages: 'trainer/loadInfoMessages',
            }),
            travel() {
                this.positionPost(journeyApi.travel(this.trainerPosition.id));
            },
            getToplist() {
                this.fetchData(journeyApi.trainersToplist(this.trainerPosition.days, this.trainerPosition.trainerFight.trainer.id)).then((data) => {
                    this.toplist = data;
                });
            },
        },
    }
</script>

<style scoped>
.twf-root {
    position: fixed;
    inset: 0;
    height: 100%;
    background-size: cover;
    background-position: center;
    overflow-y: auto;
}
.twf-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    /* poslední číslo (bottom) = rezerva pro globální TeamBottomSheet (App.vue),
       54px - viz komentář v TrainerFightWinNext.vue (.twf-root je taky fixed/inset:0) */
    padding: 74px 16px 54px 16px;
    height: 100%;
    box-sizing: border-box;
}
/* Výškový rozpočet - stejný princip jako TrainerFightWinNext.vue:
   - .twf-top-row: základní nárok 25%, smršťuje se přednostně (flex-shrink:3)
     až na min-height:20% podlahu.
   - .twf-congrats-card: jedna karta pro congrats+trenéra+žebříček, roste na
     všechno místo po top-row (flex: 1 1 auto).
   - .twf-trainer-img-wrap: uvnitř karty pevná výška.
   - .twf-toplist-scroll: flex: 1 1 auto - dostane všechno zbývající místo,
     sám scrolluje (Z7 princip). */
.twf-top-row {
    width: 100%;
    max-width: 420px;
    /* flex-basis:25% je jediný zdroj pravdy pro výšku řádku - čtvereček uvnitř
       výšku nepočítá sám (viz .twf-back-badge-img níže), jen zdědí 100% této výšky */
    flex: 0 3 25%;
    min-height: 20%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    justify-items: stretch;
}
.twf-square-tile {
    /* vyplní celou výšku řádku (flex sloupec obrázek+popisek pod sebou) - viz komentář u .twf-top-row */
    width: 100%;
    height: 100%;
    container-type: inline-size;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.twf-square-tile--disabled {
    pointer-events: none;
    opacity: 0.6;
}
.twf-square-placeholder {
    width: 100%;
}
.twf-back-badge-img {
    /* flex:1 (zbývající výška po popisku), šířka dopočtená z aspect-ratio -
       viz podrobný komentář u .tfw-back-badge-img v TrainerFightWinNext.vue */
    flex: 1 1 auto;
    min-height: 0;
    width: auto;
    max-width: 100%;
    aspect-ratio: 1;
    border-radius: 14px;
    background-size: cover;
    background-position: center;
    border: 5px solid #C0C0C0;
    box-shadow: 0 3px 8px rgba(0,0,0,0.5);
    box-sizing: border-box;
}
.twf-square-label {
    margin-top: -14px;
    position: relative;
    z-index: 1;
    background: rgba(0,0,0,0.65);
    color: #fff;
    font-size: clamp(15px, 15cqw, 30px);
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 10px;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.6);
    white-space: nowrap;
}
.twf-congrats-card {
    width: 100%;
    max-width: 420px;
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border-radius: 18px;
    padding: 6px 16px 10px 16px;
    text-align: center;
    box-shadow: 2px 3px 10px rgba(0,0,0,0.35);
    box-sizing: border-box;
}
/* titulek+podtitulek stohované nad trenérem, ale trenér+text pořád dohromady
   tvoří jeden 50% blok spolu s tabulkou - viz stejný komentář v TrainerFightWinNext.vue */
.twf-badge-block {
    flex: 1 1 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
}
.twf-congrats-title {
    flex: none;
    font-size: 26px;
    font-weight: 800;
}
.twf-congrats-subtitle {
    flex: none;
    font-size: 18px;
    font-weight: 600;
    margin-top: 2px;
}
.twf-trainer-img-wrap {
    flex: 1 1 auto;
    min-height: 0;
    margin-top: 6px;
}
.twf-trainer-img {
    height: 100%;
    width: 100%;
}
/* žebříček roste na všechno zbývající místo v kartě, sám scrolluje (Z7 princip);
   font-size dědí default ToplistTable.vue (bez vlastního zvětšení), jinak se
   Date sloupec zabaluje na víc řádků */
.twf-toplist-scroll {
    flex: 1 1 0;
    min-height: 0;
    margin-top: 8px;
    overflow-y: auto;
}
</style>
